<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box"
  >
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30" v-if="lead">
      <div class="profile-info d-sm-flex align-items-center">
        <img
          v-if="lead.user && lead.user.profil_picture"
          :src="lead.user.profil_picture"
          class="rounded w-90 h-90"
          alt="user"
        />
        <img
          v-else
          src="@/assets/images/user/avatar.png"
          class="rounded w-90 h-90"
          alt="user"
        />
        <div class="title mt-12 mt-sm-0">
          <h5 class="fs-md-15 fw-medium mb-8">{{ lead.civilite ?? "-" }}</h5>
          <span class="d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8">
            {{ lead.firstName }} {{ lead.lastName }}
          </span>
          <span class="d-block fw-bold badge text-outline-success">
            {{ lead.customer_type === "organisation" ? $t('common.company') : $t('common.customer') }}
          </span>
        </div>
      </div>
      <div
        class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"
      ></div>
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('forms.generalInfo') }}</h5>
        <!--        <router-link-->
        <!--          to="/lead-details"-->
        <!--          class="d-inline-block text-decoration-none lh-1 text-muted fw-medium"-->
        <!--        >-->
        <!--          <i-->
        <!--            class="ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1"-->
        <!--          ></i>-->
        <!--          Edit-->
        <!--        </router-link>-->
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('forms.country') }}</div>
        <div class="col-sm-8">{{ lead.country ?? "-" }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('order.postalCode') }}</div>
        <div class="col-sm-8">
          {{ displayPostalCode }}
        </div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('order.locality') }}</div>
        <div class="col-sm-8">{{ displayCity }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('order.street') }}</div>
        <div class="col-sm-8">{{ displayAddress }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('pos.streetNumber') }}</div>
        <div class="col-sm-8">{{ displayStreetNumber }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('forms.phone') }}</div>
        <div class="col-sm-8">
          {{ lead.phone_number != null ? lead.phone_number : "-" }}
        </div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('forms.firstName') }}</div>
        <div class="col-sm-8">{{ lead.first_name ?? "-" }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('forms.lastName') }}</div>
        <div class="col-sm-8">{{ lead.last_name ?? "-" }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('forms.dateOfBirth') }}</div>
        <div class="col-sm-8">{{ formattedDateOfBirth }}</div>
      </div>
      <div class="row mb-2 mt-4" v-if="lead">
        <div class="col-sm-4 fw-bold">{{ $t('forms.email') }}</div>
        <div class="col-sm-8">{{ lead.email ?? "-" }}</div>
      </div>
      <div class="mt-20 border-top pt-15 d-flex justify-content-center">
        <button
          class="btn btn-sm btn-outline-warning w-100 d-flex align-items-center justify-content-center gap-2"
          @click="$emit('generate-coupon')"
          v-if="lead.email"
        >
          <i class="fas fa-ticket-alt"></i>
          Générer un coupon manuel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "LeadsInformation",
  props: {
    lead: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  computed: {
    primaryAddress() {
      if (this.lead?.listeAdresses && this.lead.listeAdresses.length > 0) {
        return this.lead.listeAdresses[0];
      }
      return null;
    },
    displayPostalCode() {
      return this.lead?.postal_code ?? this.lead?.code_postal ?? "-";
    },
    displayCity() {
      return this.lead?.city ?? "-";
    },
    displayAddress() {
      const address = this.lead?.address ?? "-";
      if (address === "-") return address;
      
      const streetNumber = this.lead?.numeroRue;
      if (streetNumber) {
        const regex = new RegExp(`\\s*${streetNumber}\\s*$`, 'g');
        return address.replace(regex, '').trim() || "-";
      }
      
      return address.trim();
    },
    displayStreetNumber() {
      return this.lead?.numeroRue ?? "-";
    },
    formattedDateOfBirth() {
      if (!this.lead?.date_of_birth) return "-";
      
      try {
        const date = new Date(this.lead.date_of_birth);
        
        if (isNaN(date.getTime())) return this.lead.date_of_birth;
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}/${month}/${day}`;
      } catch (error) {
        return this.lead.date_of_birth;
      }
    },
  },
};
</script>
